import React, { useState, useEffect } from 'react'
import AdminLayout from '../AdminLayout'
import ContentHeader from '../layout/ContentHeader'
import FormLayout from '../layout/FormLayout'
import httpClient from '../../../http/HttpRequest'
import Alert from '../../../feature/Alert'
import { UPDATE_PROFILE, GET_PROFILE } from '../../../data/url'

export default function Profile() {
  const [directSubmit, setDirectSubmit] = useState(1);
  const [formData, setFormData] = useState({
    formTitle: 'Profile',
    formFields: [
      { label: 'first_name', id: 'first_name', type: 'text', name: 'first_name', value: '', required: true, className: "col-6" },
      { label: 'last_name', id: 'last_name', type: 'text', name: 'last_name', value: '', required: true, className: "col-6" },
      { label: 'email', id: 'email_id', type: 'email', name: 'email_id', value: '', required: true, className: "col-6" },
      { label: 'mobile', id: 'mobile', type: 'text', name: 'mobile', value: '', required: true, className: "col-6" },
    ],
    formErrors: { first_name: '', last_name: '', email_id: '', mobile: '' },
  });

  useEffect(() => {
    getProfile();
  }, []);


  function handleFieldChange(fieldName, value) {
    setDirectSubmit(0);
    setFormData((prevFormData) => {
      const updatedFormFields = prevFormData.formFields.map((field) =>
        field.name === fieldName ? { ...field, value: value } : field
      );
      return {
        ...prevFormData,
        formFields: updatedFormFields,
      };
    });
  }

  function handleFieldBlur(fieldName, value) {
    setDirectSubmit(0);
    validateField(fieldName, value);
  }

  function validateField(fieldName, value) {
    setFormData((prevFormData) => {
      const updatedErrors = { ...prevFormData.formErrors };

      if (fieldName === 'first_name') {
        updatedErrors.first_name = value.trim() === '' ? 'field_required' : '';
      } else if (fieldName === 'last_name') {
        updatedErrors.last_name = value.trim() === '' ? 'field_required' : '';
      } else if (fieldName === 'email_id') {
        updatedErrors.email_id = value.trim() === '' ? 'field_required' : '';
      } else if (fieldName === 'mobile') {
        updatedErrors.mobile = value.trim() === '' ? 'field_required' : '';
      }
      return {
        ...prevFormData,
        formErrors: updatedErrors,
      };
    });
    return formData.formErrors;

  }

  function handleSubmit(e) {
    e.preventDefault();
    let post = {};
    let hasErrors = false;
    const updatedFormFields = formData.formFields.map((field) => {
      const allError = validateField(field.name, field.value);
      const error = allError[field.name];
      if (error !== '') {
        hasErrors = true;
      } else {
        post[field.name] = field.value;
      }
      return field;
    });

    setFormData((prevFormData) => ({
      ...prevFormData,
      formFields: updatedFormFields,
    }));
    if (!hasErrors && directSubmit === 0) {
      subtmitData(post);
    }
  }

  const subtmitData = async (post) => {
    const res = await httpClient.post(UPDATE_PROFILE, post);
    if (res.requestStatus === "OK") {
      const result = res.result;
      if (result.status === 1) {
        Alert.success(result.message);
      } else {
        Alert.failure(result.message);
      }
    }
  }

  function handleReset() {
    const updatedFormFields = formData.formFields.map((field) => ({
      ...field,
      value: '',
    }));

    setFormData((prevFormData) => ({
      ...prevFormData,
      formFields: updatedFormFields,
      formErrors: {},
    }));
  }


  const getProfile = async () => {
    const res = await httpClient.post(GET_PROFILE, {});
    if (res.requestStatus === 'OK') {
      const result = res.result;
      if (result.status === 1) {
        setFormData(prevFormData => {
          const updatedFormFields = prevFormData.formFields.map(field => {
            if (field.name in result.data) {
              field.value = result.data[field.name];
            }
            return field;
          });
          return {
            ...prevFormData,
            formFields: updatedFormFields,
          };
        });
      } else {
        Alert.error(res.message);
      }
    }
  };
  return (
    <AdminLayout>
      <div className="content-wrapper">
        <ContentHeader title="profile" />
        <div className='col-md-8 m-auto'>
          <FormLayout
            formTitle={formData.formTitle}
            formFields={formData.formFields}
            formErrors={formData.formErrors}
            onFieldChange={handleFieldChange}
            onFieldBlur={handleFieldBlur}
            onSubmit={handleSubmit}
            handleReset={handleReset}
          />
        </div>
      </div>
    </AdminLayout>
  )
}
